/**
 * Content-Design-authored copy for the /sign-in/link-unavailable route
 * (design state 1.4, TG-43, Content Design Agent mandatory per the
 * constitution's trigger table for user-facing text).
 *
 * Every string below is copied byte for byte from AC-24 in
 * `specs/features/m1-magic-link-authentication-session/product-spec.md` —
 * no developer-drafted wording, no lorem, no placeholder. `helpLine` is the
 * AC-29 help line shown on views for states 1.1 to 1.4.
 *
 * This is the one view shown for every rejected link (AC-24): never
 * issued, structurally invalid, altered, expired, spent, superseded or
 * revoked, a missing or malformed fragment, and an ended session all
 * render this same body. It carries no email field, no policy number, no
 * renewal date and no account name (AC-6, AC-24), and its one action opens
 * the sign-in view rather than resending anything.
 *
 * `body` carries the static "20 minutes" text ADR-20261008-echd and AC-30
 * require: no endpoint, no request, no configuration read at render time.
 * `tests/api/test_link_validity_copy_matches_config.py` (TG-43's companion
 * test group) parses this exact string against every tier's
 * `MAGIC_LINK_TOKEN_VALIDITY_MINUTES` — do not reword "20 minutes" here
 * without updating that parse target.
 */
export const linkUnavailableContent = {
  heading: "That link no longer works",
  body: "Sign-in links work once and expire after 20 minutes.",
  newLinkActionLabel: "Get a new link",

  helpLine: "Need help? Contact your Account Manager.",
} as const;
